const createConditionsFromRegex = (regexString: string, localize: any) => {
  const conditionMap = new Map();

  // Check what the regex contains and build conditions accordingly
  if (
    regexString.includes('(?=.*[a-z])') ||
    regexString.includes('(?=.*?[a-z])') ||
    regexString.includes('(?=.*[A-Z])') ||
    regexString.includes('(?=.*?[A-Z])')
  ) {
    conditionMap.set('letterCase', {
      test: (p: string) => /(?=.*[a-z])(?=.*[A-Z])/.test(p),
      message: `${localize('password.conditions.lowercase.and.uppercase')}`,
    });
  }

  if (regexString.includes('(?=.*\\d)')) {
    conditionMap.set('digit', {
      test: (p: string) => /(?=.*\d)/.test(p),
      message: `${localize('password.conditions.number')}`,
    });
  }

  if (regexString.includes('(?=.*[\\W_])')) {
    conditionMap.set('special', {
      test: (p: string) =>
        /(?=.*[\W_])/.test(p) || /(?=.*[#?!@$%^&*-])/.test(p),
      message: `${localize('password.conditions.specialCharacter')}`,
    });
  }

  // Length detection - handle both .{8,} and .{8,32}
  const lengthMatch = regexString.match(/\.{(\d+),(\d*)}|\\.{(\d+),}/);
  if (lengthMatch) {
    const min = lengthMatch[1] || lengthMatch[3];
    const max = lengthMatch[2];
    conditionMap.set('length', {
      test: (p: string) => {
        if (max) return p.length >= parseInt(min) && p.length <= parseInt(max);
        return p.length >= parseInt(min);
      },
      message: `${localize(`password.conditions.${min}.min.length`)}`,
    });
  }

  return Array.from(conditionMap.entries()).map(([name, config]) => ({
    name,
    ...config,
  }));
};

export const usePasswordConditions = (
  password: string,
  passwordRegex: string,
  localize: any
) => {
  const conditionCheckers = createConditionsFromRegex(passwordRegex, localize);

  if (!password) {
    return {
      conditions: [],
      isValid: false,
      failedConditions: [],
      passedConditions: [],
    };
  }

  // Full regex for overall validity
  const regex = new RegExp(passwordRegex);

  // Evaluate each condition
  const conditions = conditionCheckers.map((checker) => ({
    name: checker.name,
    test: checker.test(password),
    message: checker.message,
  }));

  return {
    isValid: regex.test(password),
    conditions,
    failedConditions: conditions.filter((c) => !c.test),
    passedConditions: conditions.filter((c) => c.test),
  };
};
